'use client'

import { useEffect, useState } from 'react';
import { CustomAnalytics } from 'shared-react-components';

export default function useCustomAnalyticsState() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
    }
  }, [initialized]);

  let state;
  if (initialized) {
    state = CustomAnalytics.getState();
  }

  return {
    loading: !initialized,
    state
  };
}
